"use client";

import { useContext } from "react";
import { API_FETCHER_CONTEXT_DEFAULT_VALUE } from "../constants/contexts/defaultValues";
import { ApiFetcherContext } from "../contexts/ApiFecher/ApiFetcher";

/**
 * @typedef {object} TwoFactorAuthChallengeData
 * @prop {string} challengeId
 * @prop {string} method
 * @prop {string} expiresAt
 * @prop {string | null} email
 * @prop {string | null} phoneNumber
 */

/**
 * @callback TwoFactorAuthChallengeStartChallenge
 * @param {TwoFactorAuthChallengeData} params
 * @returns {Promise<boolean>} is success
 */

/**
 * @template [T=any]
 * @template [M=any]
 * @typedef {{ response: Response, parsedJson?: import("../types/alfred/ApiResponse").ApiResponse<T, M> | null }} ApiFetcherReturn
 */

/**
 * @typedef {(info: string | string[], init?: RequestInit) => Promise<ApiFetcherReturn<any, any>>} ApiFetcher
 */

/**
 * @typedef {(info: string, init?: RequestInit) => Promise<Response>} ServerApiFetcher
 */
export function useApiFetcher() {
  const value = useContext(ApiFetcherContext);
  if (value === API_FETCHER_CONTEXT_DEFAULT_VALUE) {
    throw new Error("useApiFetcher must be used within a ApiFetcherProvider");
  }
  return value;
}
